export default __webpack_public_path__ + "static/media/6.ae3e93e9.png";